module.exports = __webpack_public_path__ + "static/media/planoa.2e5b2028.png";